import { render, staticRenderFns } from "./FamilyQuestionDisplay.vue?vue&type=template&id=7dd4d910&scoped=true"
import script from "./FamilyQuestionDisplay.vue?vue&type=script&lang=js"
export * from "./FamilyQuestionDisplay.vue?vue&type=script&lang=js"
import style0 from "./FamilyQuestionDisplay.vue?vue&type=style&index=0&id=7dd4d910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd4d910",
  null
  
)

export default component.exports